// outer
import { useEffect } from 'react';
import { isIOS, isAndroid, isDesktop } from 'react-device-detect';

// widgets
import { PageTemplate } from '@_widgets/common';
import { SocialIcon } from '@_widgets/user';

// features
import { loginLogic, useLoginErrorHandle } from '@_features/auth';

// entities
import { TERMS_CONSTANTS } from '@_entities/system';

// shared
import { AppleIcon, KakaoIcon, TTKLogoIcon } from '@_shared/icons';
import { CHARACTER_IMGS } from '@_shared/imgs';
import { Typography } from '@_shared/ui/Typography';

// inner
import * as S from './LoginPage.style';

export function LoginPage() {
	useLoginErrorHandle();

	useEffect(() => {
		loginLogic.kakaoInit();
	}, []);

	return (
		<PageTemplate header={false} nav={false}>
			<S.Container>
				{/* Header */}
				<S.Header>
					<Typography type="title-medium" color="orange-primary" textAlign="center">
						클릭 한번에 모든 콘텐츠를 담다
					</Typography>
					<TTKLogoIcon />
				</S.Header>

				<S.MessageContainer>
					<S.FloatingMessage>
						<Typography type="label-large" color="font-primary" textAlign="center">
							쉽고 빠른 콘텐츠 저장, 앵심이와 시작해보세요!
						</Typography>
					</S.FloatingMessage>
					<S.Image src={CHARACTER_IMGS.GO_CHARACTER_IMG} alt="GO_CHARACTER_IMG" />
				</S.MessageContainer>

				{/* Login Button */}
				<S.LoginButtonContainer>
					{isIOS ? (
						<S.OAuthSquareButton
							bgColor="black"
							color="white"
							onClick={() => {
								loginLogic.appleLogin();
							}}
						>
							<AppleIcon />
							<span>Apple로 시작하기</span>
						</S.OAuthSquareButton>
					) : (
						<S.OAuthSquareButton
							bgColor="#ffe812"
							color="black"
							onClick={() => {
								loginLogic.kakaoLogin();
							}}
						>
							<KakaoIcon />
							<span>카카오톡으로 시작하기</span>
						</S.OAuthSquareButton>
					)}

					<S.SeperateTextLine>또는</S.SeperateTextLine>

					<S.OAuthCircleButtons>
						{isIOS && (
							<SocialIcon
								type="kakao"
								size="40px"
								onClick={() => {
									loginLogic.kakaoLogin();
								}}
							/>
						)}

						<SocialIcon
							type="naver"
							size="40px"
							onClick={() => {
								loginLogic.naverLogin();
							}}
						/>
						{(isAndroid || isDesktop) && (
							<SocialIcon
								type="google"
								size="40px"
								onClick={() => {
									loginLogic.googleLogin();
								}}
							/>
						)}
					</S.OAuthCircleButtons>
				</S.LoginButtonContainer>

				<S.FooterTerms>
					<Typography
						type="label-large"
						color="font-tertiary"
						onClick={() => {
							window.location.href = TERMS_CONSTANTS.TERMS_OF_SERVICE;
						}}
					>
						이용약관
					</Typography>
					<Typography type="label-large" color="font-tertiary">
						|
					</Typography>
					<Typography
						type="label-large"
						color="font-tertiary"
						onClick={() => {
							window.location.href = '/terms/2';
						}}
					>
						개인정보처리방침
					</Typography>
				</S.FooterTerms>
			</S.Container>
		</PageTemplate>
	);
}
